<template>
  <FormGroupHorizontal 
    :label="$t('engine.manageText.modalWidget.lblSize', languageEngine)"
    :labelValign="'center'"
    :split="'3:9'"
    :paddingClosest="'8'"
  >
    <FontSize
      :fontSize="_value"
      :optionSize="optionSize"
      :menuMaxHeight="'300px'"
      :menuDrop="'left'"
      @change="onChange"
    />
  </FormGroupHorizontal>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import FontSize from "@components_system/Shared/Tools/FontSize/FontSize";

export default {
  components: {
    FormGroupHorizontal,
    FontSize,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    value() {
      return this.texteditor.selectionFormatMerge.size;
    },
    _value() {
      if (Array.isArray(this.value)) return this.value[0];
      return this.value;
    },
    optionSize() {
      if (this.texteditor.formats && this.texteditor.formats.size && this.texteditor.formats.size.max == '30px') {
        return "8_30";
      } else if (this.texteditor.formats && this.texteditor.formats.size && this.texteditor.formats.size.max == '60px') {
        return "8_60";
      }
      return undefined;
    }
  },
  methods: {
    onChange(value) {
      const selection = this.texteditor.editor.getSelection();
      let selectionLength = selection.length;
      let [line1, offset1] = this.texteditor.editor.getLine(selection.index);
      let lines = this.texteditor.editor.getLines(selection);

      let format = value ? `${value}px` : false;

      if (lines.length > 1) {
        let selectionLengthRemain = selectionLength;

        lines.forEach((line, i) => {
          let isFirst = Boolean(i == 0);
          let lineLength = line.cache.length - 1; // 10
          let lineLengthWithBreak = line.cache.length; // 11
          let lineIndex = this.texteditor.editor.getIndex(line); // 10
          let offsetOfLine = isFirst ? offset1 : 0; // 11, 0

          let lineSelection = {
            index: lineIndex + offsetOfLine,
            length: lineLengthWithBreak - offsetOfLine,
          };
          if (lineSelection.length > selectionLengthRemain) lineSelection.length = selectionLengthRemain;

          const selectionAllInLine = Boolean(offsetOfLine == 0 && (lineSelection.length == lineLength || lineSelection.length == lineLengthWithBreak));
          
          if (selectionAllInLine) {
            this.texteditor.editor.formatLine({ index: lineSelection.index, length: lineSelection.length }, {
              'lineSize': format,
            });
            this.texteditor.editor.formatText({ index: lineSelection.index, length: lineSelection.length }, {
              'size': format,
              'sizeAttribute': format,
            });
          } else {
            this.texteditor.editor.formatText({ index: lineSelection.index, length: lineSelection.length }, {
              'size': format,
              'sizeAttribute': format,
            });
          }

          selectionLengthRemain = selectionLengthRemain - lineSelection.length;
        });

      } else {
        let lineLength = line1.cache.length - 1;
        let lineLengthWithBreak = line1.cache.length;

        const selectionAllInLine = Boolean(offset1 == 0 && (selection.length == lineLength || selection.length == lineLengthWithBreak));

        if (selectionAllInLine) {
          this.texteditor.editor.formatLine(selection, {
            'lineSize': format,
          });
          this.texteditor.editor.formatText({ index: selection.index, length: selection.length }, {
            'size': format,
            'sizeAttribute': format,
          });
        } else {
          this.texteditor.editor.formatText({ index: selection.index, length: selection.length }, {
            'size': format,
            'sizeAttribute': format,
          });
        }
      }
    }
  },
}
</script>
